"use strict";
/**
 * Set pre-order text on products using PreProduct Pre-Order app
 *
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Alexandra Miro
 */
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var setPreOrderText = function () {
    var preOrderDays = document.getElementById('preOrderDays');
    if (!preOrderDays)
        return;
    window.addEventListener('ppJustLaunched', function () {
        var _a;
        var todaysDate = new Date();
        var numberOfDaysToAdd = (_a = window === null || window === void 0 ? void 0 : window.preproduct) === null || _a === void 0 ? void 0 : _a.lead_time;
        var newDate = date_fns_1.addDays(todaysDate, numberOfDaysToAdd);
        var formattedDate = date_fns_1.format(newDate, 'do');
        var formattedDateMonth = date_fns_1.format(newDate, 'MMMM');
        // const el = document.getElementById('preorder--text');
        // if (el){
        //     el.innerHTML = `Pre-order shipping from ${formattedDate} of ${formattedDateMonth}`;
        // }
    }, false);
};
exports.default = setPreOrderText;
